import React from 'react'
import styles from './TripLaps.scss'
import { FullBleedList } from 'common/FullBleedList'
import { Distance, Elevation, Duration } from 'common/units'
import { featureTypes } from 'common/MapV2/featureTypes'
import { Msg, commonNouns } from 'lib/localization'
import { TrackLocation } from 'data/records'

const TripLap = ({ lap, i, onFeatureSelected, onFeatureHovered }) => {
  const feature = {
    type: featureTypes.LAP,
    firstI: lap.first_i,
    data: {
      highlightSlice: [
        TrackLocation({ left: lap.first_i, pct: 0 }),
        TrackLocation({ left: lap.last_i, pct: 0 })
      ],
      lapNumber: i + 1
    }
  }

  return (
    <li
      className={styles.TripLap}
      onMouseOver={() => onFeatureHovered(feature)}
      onMouseOut={() => onFeatureHovered(null)}
      onClick={() => onFeatureSelected(feature)}>
      <div>#{i + 1} – <Duration biggestUnits valueOnly value={lap.moving_time} /></div>
      <div className={styles.metrics}>
        <span className={styles.eleGain}>+<Elevation short value={lap.elevation_gain} /></span>
        <span className={styles.distance}><Distance short value={lap.distance} bigUnits /></span>
      </div>
    </li>
  )
}

export class TripLaps extends React.PureComponent {
  render () {
    const { trip, onFeatureHovered, onFeatureSelected } = this.props
    if (!trip.lapSummaries || trip.lapSummaries.length === 0) {
      return null
    }

    return (
      <div className={styles.TripLaps}>
        <h2><Msg capitalized m={commonNouns.laps} values={{ count: 0 }} /></h2>
        <FullBleedList>
          {trip.lapSummaries.map((lap, i) => <TripLap
            key={i}
            lap={lap}
            i={i}
            onFeatureHovered={onFeatureHovered}
            onFeatureSelected={onFeatureSelected} />
          )}
        </FullBleedList>
      </div>
    )
  }
}
